import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBullhorn } from "@fortawesome/pro-regular-svg-icons";
import DirectoryRowBadge from "components/directory/DirectoryRowBadge";

type ChannelHitArgs = {
  id: string;
  slug: string;
  description: string;
  status: string;
  title: string;
  subscribers_count: number;
  image_id?: string;
};

export default function ChannelHit({
  slug,
  description,
  status,
  title,
  subscribers_count,
  image_id,
}: ChannelHitArgs) {
  return (
    <div className="ChannelHit border-box">
      <div className="flex gap-2 px-3 py-2">
        <div className="w-16 h-16 flex-shrink-0 items-center justify-center">
          {image_id ? (
            <img
              className="h-16 w-16 rounded-full object-cover"
              src={`/api/storage/images/${image_id}/get/200x200`}
              alt=""
            />
          ) : (
            <div className="flex h-16 w-16 items-center align-middle justify-center border border-neutral border-solid border-1 rounded-full bg-neutral">
              <FontAwesomeIcon
                className="max-h-16 max-w-16 text-white"
                icon={faBullhorn}
                size="2xl"
              />
            </div>
          )}
        </div>
        <div className="media-body grow">
          <div className="flex items-center gap-1">
            <a href={`/channels/${slug}`} className="media-heading font-medium">
              {title}
            </a>
            {(status === "draft" || status === "archived") && (
              <DirectoryRowBadge
                tooltipTitle={I18n.t(
                  `js.directory.channel_row.status.${status}`,
                )}
                title={I18n.t(`js.directory.channel_row.status.${status}`)}
                className="text-muted bg-gray-100"
              />
            )}
          </div>
          <p className="text-muted text-sm">
            {I18n.t("js.directory.channel_row.subscriptions_count", {
              count: subscribers_count,
            })}
          </p>
          <p className="max-w-4xl mt-1 text-sm whitespace-pre-line">
            {description}
          </p>
        </div>
      </div>
      <div className="border-neutral border-dashed border-t">
        <a className="btn btn-link block" href={`/channels/${slug}`}>
          {I18n.t("js.global_search.channels.show_title")}
        </a>
      </div>
    </div>
  );
}
